export class eMonitorMessageModel {
    constructor(
        public messageName: string,
        public messageContent: string,
        ){}
}
